<template>
  <v-menu
    v-if="hasAnyItemsInMenu"
    v-model="showingMenu"
    :target="[positionX, positionY]"
    :close-on-content-click="false"
    :persistent="false"
    location="bottom"
    absolute
    z-index="2"
  >

    <v-list width="180px" data-cy="list-podItem-actions-list">

      <v-list-item
        v-if="$canDeleteNodeAndPod() && !asSearchResult"
        @click="openDeletePodDialog"
        data-cy="list-podItem-actions-deletePod"
        prepend-icon="mdi-trash-can-outline"
      >
        <v-list-item-title>{{ $t('routes.node.deletePod') }}</v-list-item-title>
      </v-list-item>

      <v-list-item @click="openPodPropertiesDialog" prepend-icon="mdi-information-outline">
        <v-list-item-title>{{ $t('routes.node.properties') }}</v-list-item-title>
      </v-list-item>

    </v-list>
  </v-menu>

  <!-- Standalone dialogs -->
  <DeletePodDialog
    v-if="$canDeleteNodeAndPod() && !asSearchResult"
    :pod="item"
    v-model="showDeletePodDialog"
  />

  <PodPropertiesDialog
    :pod="item"
    v-model="showPodPropertiesDialog"
  />
</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useCommonStore } from '@/stores/CommonStore.js';
import DeletePodDialog from "../dialogs/DeletePodDialog.vue";
import PodPropertiesDialog from "../dialogs/PodPropertiesDialog.vue";

export default {
  emits: ['update:modelValue'],
  name: "ArchivedPodContextMenu",

  components: {
    DeletePodDialog,
    PodPropertiesDialog,
  },

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    asSearchResult: {
      type: Boolean,
      default: false,
    },
    positionX: {
      type: Number,
      required: true,
    },
    positionY: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      // required: true,
    },
  },

  data() {
    return {
      showDeletePodDialog: false,
      showPodPropertiesDialog: false,
    };
  },

  watch: {
    podFromState() {
      if (this.podFromState && this.podFromState.archived !== this.archiveStatus.ARCHIVED) {
        this.showingMenu = false;
      }
    },
  },

  methods: {
    openDeletePodDialog() {
      this.showingMenu = false;
      this.$nextTick(() => {
        this.showDeletePodDialog = true;
      });
    },
    openPodPropertiesDialog() {
      this.showingMenu = false;
      this.$nextTick(() => {
        this.showPodPropertiesDialog = true;
      });
    },
    stub() {
      this.showingMenu = false;
    },
  },

  computed: {
    showingMenu: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    archiveStatus() {
      const commonStore = useCommonStore();
      return commonStore.archiveStatus;
    },
    podFromState() {
      if (!this.item) {
        return;
      }

      const podStore = usePodStore();
      return podStore.getPods.filter((x) => x.id === this.item.id);
    },
    hasAnyItemsInMenu() {
      // return this.$canControlNodeAndPod() ||
      //         this.$canDownloadNodeAndPod();
      return true;  // The properties is always there
    },
  }
};
</script>

<style>
</style>
